import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ManageStocks from "./components/ManageStocks/ManageStocks";
import ApplyIndicators from "./components/ManageStocks/ApplyIndicators";
import BaseLayout from "./containers/BaseLayout";
import Home from "./containers/Home";
import ZerodhaLogin from "./components/Zerodha/ZerodhaLogin";
import ZerodhaHoldings from "./components/Zerodha/Holdings";
import ZerodhaExecute from "./components/Zerodha/Execute";
import ZerodhaInstruments from "./components/Zerodha/Instruments";
import ZerodhaTrades from "./components/Zerodha/TradeAlerts";
import TrackTradeAlert from "./components/Zerodha/TrackTradeAlert";
import Blogs from "./containers/Blogs";
import Contact from "./containers/Contact";
import NoPage from "./containers/NoPage";
import LoginPage from './components/Common/Login';
import Account from './components/Common/Account';
import ManageConfiguration from './components/ManageConfiguration/ManageConfiguration';
import AddEditConfiguration from './components/ManageConfiguration/AddEditConfiguration';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import ManageUser from './components/ManageUser/ManagerUser';
import ManageTracking from './components/ManageTracking/ManageTracking';
import ManageTags from './components/ManageTags/ManageTags';
import ManageLeverage from './components/ManageLeverage.js/ManageLeverage';
import CronJob from "./components/Admin/CronJob/CronJobs";
import AlertTrade from "./components/Admin/AlertTrade/AlertTrade";
import CompanyValidate from "./components/Admin/CompanyValidate/companyValidate";
import StrategyAnalysis from "./components/Admin/StrategyAnalysis/index";
import AdminHome from "./components/Admin/Home/index";
import Testing from './components/Common/Testing';
import AccessControl from './components/Admin/AccessControl/AccessControl';
import AddEditTags from './components/ManageTags/AddEditTags';
import AdminActions from './components/Admin/Actions';

const routeToLeftNavMapping = [
  {
    '/admin': 'ADMIN_MAIN_LEFT_NAV'
  },
  {
    '/zerodha': 'ZERODHA_LEFT_NAV'
  },
  {
    '/': 'MAIN_LEFT_NAV'
  }
]


function App() {

  return (
    <div className="App">
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          {/* Login Page without BaseLayout */}
          <Route path="/login" element={<LoginPage />} />

          {/* Other Routes with BaseLayout */}
          <Route
            path="*"
            element={
              <BaseLayout routeToLeftNavMapping={routeToLeftNavMapping}>
                <Routes>
                  {/* Home Page Routes */}
                  <Route path="/stocks" element={<ManageStocks />} />
                  <Route path="/indicators" element={<ApplyIndicators />} />
                  <Route path="/strategy" element={<StrategyAnalysis />} />
                  <Route path="/users" element={<ManageUser />} />
                  <Route path="/configurations/edit" element={<AddEditConfiguration key="configurations-edit" />} />
                  <Route path="/configurations/copy" element={<AddEditConfiguration key="configurations-copy" />} />
                  <Route path="/configurations/add" element={<AddEditConfiguration key="configurations-add" />} />
                  <Route path="/configurations" element={<ManageConfiguration key="configurations" />} />
                  <Route path="/master-configurations/edit" element={<AddEditConfiguration key="master-configurations-edit" />} />
                  <Route path="/master-configurations/copy" element={<AddEditConfiguration key="master-configurations-copy" />} />
                  <Route path="/master-configurations/add" element={<AddEditConfiguration key="master-configurations-add" />} />
                  <Route path="/master-configurations" element={<ManageConfiguration key="master-configurations" />} />
                  <Route path="/dashboard" element={<Home />} />
                  <Route path="/leverages" element={<ManageLeverage />} />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/testing" element={<Testing />} />
                  <Route path="/trackings" element={<ManageTracking />} />
                  <Route path="/tags/edit" element={<AddEditTags />} />
                  <Route path="/tags/add" element={<AddEditTags />} />
                  <Route path="/tags/copy" element={<AddEditTags />} />
                  <Route path="/tags" element={<ManageTags />} />


                  {/* Admin routes */}
                  <Route path="/admin/company/validate" element={<CompanyValidate />} />
                  <Route path="/admin/cronjob" element={<CronJob />} />
                  <Route path="/admin/trade-alerts" element={<AlertTrade />} />
                  <Route path="/admin/access-control" element={<AccessControl />} />
                  <Route path="/admin/actions" element={<AdminActions />} />

                  {/* Zerodha Holdings*/}
                  <Route path="/zerodha/login" element={<ZerodhaLogin />} />
                  <Route path="/zerodha/execute" element={<ZerodhaExecute />} />
                  <Route path="/zerodha/holdings" element={<ZerodhaHoldings />} />
                  <Route path="/zerodha/instruments" element={<ZerodhaInstruments />} />
                  <Route path="/zerodha/trades" element={<ZerodhaTrades />} />
                  <Route path="/zerodha/track/trades" element={<TrackTradeAlert />} />


                  {/* Default Fallback Routes */}
                  <Route path="/admin" element={<AdminHome />} />
                  <Route path="/" element={<Home />} />
                  <Route path="*" element={<NoPage />} />
                </Routes>
              </BaseLayout>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
